"use strict";

class AgregarController {
  constructor(
    $uibModalInstance,
    data,
    $log,
    DataService,
    Message,
    $state,
    $scope,
    $http,
    apiUrl,
    Loading,
    helpLang,
    Storage
  ) {
    "ngInject";
    this.persona = data;
    this.$uibModalInstance = $uibModalInstance;
    this.$log = $log;
    this.DataService = DataService;
    this.Message = Message;
    this.$state = $state;
    this.$scope = $scope;
    this.apiUrl = apiUrl;
    this.$http = $http;
    this.Loading = Loading;
    this.helpLang = helpLang;
    this.Storage = Storage;
  }

  $onInit() {
    this.codigoMunicipio = "";
    this.entidades = [];
    this.ubicaciones = [];
    this.validacion = false;
    this.departamentos = [];
    this.provincias = [];
    this.municipios = [];
    this.departamento = { nombre: "" };
    this.provincia = { nombre: "" };
    this.niveles = [
      { codigo: 1, nombre: "Departamental" },
      { codigo: 2, nombre: "Provincial" },
      { codigo: 3, nombre: "Municipal" },
    ];
    this.nivel = 0;
    // this.obtenerEntidades();
  }

  verificarMunicipio() {
    this.DataService.get(
      `centralizador/dpa/verifica/${this.codigoMunicipio}`
    ).then((respuesta) => {
      this.validacion = respuesta.finalizado;
      this.registro = respuesta.datos;
      this.municipios = respuesta.datos.municipios_ubigeo;
      this.departamento = {
        nombre: this.registro.departamento,
        id: this.registro.departamento_id_ubigeo,
      };
      this.provincia = {
        nombre: this.registro.provincia,
        id: this.registro.provincia_id_ubigeo,
      };
      this.$log.log("Respuesta de servicio", this.registro);
      this.obtenerEntidades();
      this.obtenerUbicacionesGeograficas();
    });
  }

  obtenerEntidades() {
    this.DataService.get(`centralizador/sigep/entidades`).then((respuesta) => {
      this.entidades = respuesta.datos;
    });
  }

  obtenerUbicacionesGeograficas() {
    this.DataService.get(`centralizador/sigep/ubigeo`).then((respuesta) => {
      this.departamentos = respuesta.datos;
    });
    this.$log.log("Respuesta de ubicaciones geograficas", this.departamentos);
  }

  crearEntidadCobro(form) {
    this.$log.log("Formulario sin validar aun");
    if (form.$valid) {
      this.dpa = {
        municipio: { cod_municipio: this.codigoMunicipio },
        entidad: {
          entidad: String(this.entidad.entidad),
          id_entidad: String(this.entidad.idEntidad),
          desc_entidad: this.entidad.descEntidad,
        },
      };
      if (this.nivel.codigo == 1) {
        this.dpa.geografico = { id_ubigeo: this.departamento.id };
      }
      if (this.nivel.codigo == 2) {
        this.dpa.geografico = { id_ubigeo: this.provincia.id };
      }
      if (this.nivel.codigo == 3) {
        this.dpa.geografico = { id_ubigeo: this.municipio.id_ubigeo };
      }

      this.DataService.post(`centralizador/dpa`, this.dpa)
        .then((response) => {
          if (response) {
            this.$log.log("Respuesta servicio post", response);
            this.Message.success("Entidad de cobro registrado exitosamente");
            this.$uibModalInstance.close(/*Algun valor*/);
          }
        })
        .catch((error) => {
          this.datosPcd = {};
          this.cancel();
          this.msgError(error);
        });
    }
  }

  cancel() {
    this.$uibModalInstance.dismiss("cancel");
  }
}

export default AgregarController;



// WEBPACK FOOTER //
// ./src/app/components/entidades/entidades.agregar.controller.js